const dateMask = {
	mask: Date,
	pattern: '`m/`Y',
	blocks: {
		m: {
			mask: IMask.MaskedRange,
			from: 1,
			to: 12,
			maxLength: 2,
		},
		Y: {
			mask: IMask.MaskedRange,
			from: 1900,
			to: 2200,
		},
	},
	format: function (date) {
		var month = date.getMonth() + 1;
		var year = date.getFullYear();

		if (month < 10) month = '0' + month;

		return [month, year].join('/');
	},
	parse: function (str) {
		var monthYear = str.split('/');

		return new Date(monthYear[1], monthYear[0] - 1, 1);
	},
	min: new Date(1920, 0, 1),
	max: new Date(),
	autofix: false,
	lazy: true,
	overwrite: true,
};

export default dateMask;
